/**
 * "19 Oct 2026 09:21" — the minute of a pass, as Executions writes it,
 * in the browser's time as before: the day as every table of the app
 * writes it. Shared since CU-869fmm943 so Real time's "Launched by the
 * pass of …" says exactly what the pass's row says.
 */
import { format } from 'date-fns'
import { displayDay } from '../../../../@utils/displayDay.js'

export function fmtSlot(iso) {
	if (!iso) return '—'
	const d = new Date(iso)
	if (Number.isNaN(d.getTime())) return String(iso)
	return `${displayDay(format(d, 'yyyy-MM-dd'))} ${format(d, 'HH:mm')}`
}
